if (!customElements.get("video-carousel")) {
  class VideoCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.modals = Array.from(this.querySelectorAll("site-modal"));
      this.attachTriggers();
    }

    attachTriggers() {
      this.modals.forEach((modal) => {
        const triggerSelector = modal.dataset.trigger;
        if (!triggerSelector) return;

        const triggers = Array.from(this.querySelectorAll(triggerSelector));
        if (!triggers.length) return;

        const video = modal.querySelector("video");
        if (!video) return;

        triggers.forEach((trigger) => {
          trigger.addEventListener("click", () => {
            this.startVideoPlayback(video);
          });
        });
      });
    }

    startVideoPlayback(video) {
      const sources = Array.from(video.querySelectorAll("source[data-src]"));
      let needsLoad = false;

      sources.forEach((source) => {
        if (!source.src) {
          source.src = source.dataset.src;
          needsLoad = true;
        }
      });

      if (needsLoad) {
        video.load();
      }

      video.play().catch(() => {});
    }
  }

  customElements.define("video-carousel", VideoCarousel);
}
